import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from '@/app/App';
import { legacyHomeTarget } from '@/app/legacyHost';
import { reloadForNewVersion } from '@/app/RouteError';
import { initLanguage } from '@/i18n';
import { applyStoredColorMode } from '@/ui/colorMode';
import './ui/styles.css';

// A tab opened before a deploy asks for code chunks the new build replaced: load the new build
// (once a minute at most) instead of failing on the next screen.
window.addEventListener('vite:preloadError', (event) => {
  if (reloadForNewVersion()) event.preventDefault();
});

// before the first paint, so a dark-mode admin never sees a white flash
applyStoredColorMode();

// the retired Home hosts serve only /tech here; any other path there goes to Manhattan's host
const legacy = legacyHomeTarget(window.location);
if (legacy) {
  window.location.replace(legacy);
} else {
  // the admin's language loads first (English is bundled), so nobody sees an English flash
  void initLanguage().finally(() =>
    createRoot(document.getElementById('root')!).render(
      <StrictMode>
        <App />
      </StrictMode>,
    ),
  );
}
